const ko = {
    '例子': '예문',
}
export default ko;